__turbopack_context__.v({
  "total-ads": "AdsCount-module-scss-module__hbEjGW__total-ads",
});
